import React, { useContext, useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import { FaPlusSquare, FaThList } from "react-icons/fa"; // ✅ Импорт новых иконок
import ListGroup from "react-bootstrap/ListGroup";
import {Badge, Button, Col, Row } from "react-bootstrap";
import CreateBook from "../modals/book/CreateBook";
import {fetchCurrentUserBooks} from "../../http/bookAPI";

const ColAuthor = observer(({ onBookSelect, setActiveComponent, onClose }) => {
    const { book } = useContext(Context);
    const {user} = useContext(Context)
    const [hoveredItemId, setHoveredItemId] = useState(null);
    const [addbookVisible, setAddBookVisible] = useState(false);
    const demoBooks = [
        {
            id: 'demo-1',
            title: 'Demo Book: The Shadow Algorithm',
            subtitle: 'A Tale of AI & Ambition',
            author: 'Jane Doe',
            status: 'NEW',
            cover_file: 'demo_cover_1.jpg',
            summary: 'A thrilling journey into a world where algorithms predict destinies. Can free will survive?',
            language: 'English',
            kindle_flag: true,
            kindle_unlimited_flag: false,
            paper_back_flag: true,
            hard_cover_flag: false,
            audio_flag: false,
            total_words: '82000',
            createdAt: new Date().toISOString(),
            default_price: 999,
            kindle_asin: 'DEMOASIN1',
            paper_back_asin: 'DEMOASINPB1',
        },
        {
            id: 'demo-2',
            title: 'Demo Book: Mastering Kindle',
            subtitle: 'How to Publish and Profit',
            author: 'John Writer',
            status: 'LIVE',
            cover_file: 'demo_cover_2.jpg',
            summary: 'An essential guide for self-publishing success on Amazon Kindle. Practical and tested tips.',
            language: 'English',
            kindle_flag: true,
            kindle_unlimited_flag: true,
            paper_back_flag: false,
            hard_cover_flag: false,
            audio_flag: false,
            total_words: '56000',
            createdAt: new Date().toISOString(),
            default_price: 1200,
            kindle_asin: 'DEMOASIN2',
        },
        {
            id: 'demo-3',
            title: 'Demo Book: Royalties Made Simple',
            subtitle: 'Earn More from Every Book',
            author: 'Linda Roy',
            status: 'NEEDFIX',
            cover_file: 'demo_cover_3.jpg',
            summary: 'Learn how to optimize your pricing and royalty options on Amazon with this actionable guide.',
            language: 'English',
            kindle_flag: true,
            kindle_unlimited_flag: true,
            paper_back_flag: true,
            hard_cover_flag: false,
            audio_flag: true,
            total_words: '47000',
            createdAt: new Date().toISOString(),
            default_price: 1099,
            kindle_asin: 'DEMOASIN3',
            audio_asin: 'DEMOAUD3',
        },
        {
            id: 'demo-4',
            title: 'Demo Book: Amazon BSR Secrets',
            subtitle: 'Crack the Best Seller Code',
            author: 'Alex Ranker',
            status: 'NEW',
            cover_file: 'demo_cover_4.jpg',
            summary: 'Uncover the strategies behind Amazon’s Bestseller Rank. Data-driven insights and case studies.',
            language: 'English',
            kindle_flag: true,
            kindle_unlimited_flag: true,
            paper_back_flag: false,
            hard_cover_flag: false,
            audio_flag: false,
            total_words: '65000',
            createdAt: new Date().toISOString(),
            default_price: 899,
            kindle_asin: 'DEMOASIN4',
        },
        {
            id: 'demo-5',
            title: 'Demo Book: Self-Publishing 101',
            subtitle: 'Launch Your First Book with Confidence',
            author: 'Emma Publish',
            status: 'LIVE',
            cover_file: 'demo_cover_5.jpg',
            summary: 'Step-by-step playbook to self-publish your first book — from idea to launch.',
            language: 'English',
            kindle_flag: true,
            kindle_unlimited_flag: true,
            paper_back_flag: true,
            hard_cover_flag: true,
            audio_flag: false,
            total_words: '99000',
            createdAt: new Date().toISOString(),
            default_price: 1399,
            kindle_asin: 'DEMOASIN5',
            paper_back_asin: 'DEMOPB5',
            hard_cover_asin: 'DEMOHC5',
        },
    ];


    const handleCloseAddBook = (newBookId) => {
        fetchCurrentUserBooks(user.user.id)
            .then((data) => {
                book.setCurrentUserBooks(data);
                const newlyCreatedBook = data.find((b) => String(b.id) === String(newBookId));
                if (newlyCreatedBook) {
                    handleClick(newlyCreatedBook);
                } else {
                    setTimeout(() => findAndSelectNewBook(newBookId, book.currentuserbooks), 500);
                }
            })
            .catch((err) => console.error("❌ Error:", err));

        setAddBookVisible(false);
    };


    const findAndSelectNewBook = (newBookId, updatedBooks) => {


    const newlyCreatedBook = updatedBooks.find((b) => String(b.id) === String(newBookId));

    if (newlyCreatedBook) {

        handleClick(newlyCreatedBook);
    } else {

    }
};

    const addBookInDash = () => {
        user?.setActiveComponent("AddBookInDashboard");
        if (onClose) {
            onClose();
        }
    }

    const addBookGrab = () => {
        user?.setActiveComponent("AddBookByGrabFromAmazon");
        if (onClose) {
            onClose();
        }
    }

    const addProductGrab = () => {
        user?.setActiveComponent("AddProductByGrabFromAmazon");
        if (onClose) {
            onClose();
        }
    }
    const ChooseAddTypePage = () => {
        user?.setActiveComponent("ChooseAddTypePage");
        if (onClose) {
            onClose();
        }
    }


const handleClick = (b) => {

        book.setSelectedCurrentUserBook(b);
        onBookSelect(b);
        if (onClose) {
            onClose();
        }

    };

const viewAllBooks = () => {
        user?.setActiveComponent("BookUserList");
        if (onClose) {
            onClose();
        }
    };


    const isDemoMode = book.currentuserbooks.length === 0;

    const booksToRender = isDemoMode
        ? demoBooks
        : [...(book.currentuserbooks || [])].sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));



    return (
        <div>
            <h5 style={{ marginBottom: '-16px' }} className="mx-auto p-2 text-muted">Your Books/Products</h5>

            <div style={{ marginBottom: '5px', fontSize: 'small' }} className="mx-auto p-2 text-muted">
                {isDemoMode
                    ? 'You haven’t added any books yet. Demo books just to show how it looks. They’ll disappear after you add yours.'
                    : 'Select a book/product to manage assignments:'}
            </div>
            <Col style={{ maxHeight: 400, overflowY: "auto" }}>
            <ListGroup key={booksToRender.length}

            style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}
            >
                {booksToRender.map(b => (
                    <ListGroup.Item
                        key={b.id}
                        className={`list-group-item list-group-item-action small truncated-text shadow-sm ${hoveredItemId === b.id || book.selectedCurrentUserBook?.id === b.id ? 'list-group-item-success' : ''}`}
                        style={{
                            cursor: isDemoMode ? 'not-allowed' : 'pointer',
                            opacity: isDemoMode ? 0.85 : 1,
                            borderRadius: '.25rem',
                            transition: 'transform .2s',
                            boxShadow: hoveredItemId === b.id || book.selectedCurrentUserBook?.id === b.id ? '0px 4px 12px rgba(0, 0, 0, 0.1)' : 'none',
                            paddingTop: '0.20rem',
                            paddingBottom: '0.20rem',
                        }}
                        onMouseEnter={() => !isDemoMode && setHoveredItemId(b.id)}
                        onMouseLeave={() => !isDemoMode && setHoveredItemId(null)}
                        onClick={() => {
                            if (!isDemoMode) handleClick(b);
                        }}
                    >
                        <Col className="d-flex align-items-start">
            <span style={{
                marginLeft: "15px",
                marginRight: "0px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "block",
                maxWidth: "105%"
            }}>
                {b.title}
            </span>
                        </Col>
                        {b.status === 'DELETED' && (
                            <Badge bg="danger" pill className="position-absolute ms-3 top-50 start-0 translate-middle">D</Badge>
                        )}
                        {b.status === 'SUSPENDED' && (
                            <Badge bg="warning" pill className="position-absolute text-dark  ms-3 top-50 start-0 translate-middle">S</Badge>
                        )}

                        {b.status === 'LIVE' && (
                            <Badge bg="success" pill className="position-absolute ms-3 top-50 start-0 translate-middle">L</Badge>
                        )}
                        {b.status === 'NEW' && (
                            <Badge bg="info" pill className="position-absolute text-dark ms-3 top-50 start-0 translate-middle">M</Badge>
                        )}
                        {b.status === 'NEEDFIX' && (
                            <Badge bg="warning" pill className="position-absolute text-dark ms-3 top-50 start-0 translate-middle">N</Badge>
                        )}
                    </ListGroup.Item>
                ))}



            </ListGroup>
            </Col>
            <div className="mt-2">
                <Row className="justify-content-center">
                    <Col xs="auto" className="d-flex flex-wrap justify-content-center">
                        <Button
                            variant="outline-success"
                            className="m-1 shadow-sm btn-sm d-flex align-items-center"
                            onClick={ChooseAddTypePage}
                            title="Coming soon"
                        >
                            <FaPlusSquare className="me-2" /> Add New
                        </Button>

                        <Button
                            variant="outline-success"
                            className="m-1 shadow-sm btn-sm d-flex align-items-center"
                            onClick={viewAllBooks}
                        >
                            <FaThList className="me-2" /> View all
                        </Button>

                    </Col>

                </Row>






            </div>
            <CreateBook show={addbookVisible} handleClose={handleCloseAddBook} />
        </div>
    );
});

export default ColAuthor;
